import { render, staticRenderFns } from "./StickyAlerts.vue?vue&type=template&id=adbb86f8&"
import script from "./StickyAlerts.vue?vue&type=script&lang=js&"
export * from "./StickyAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports